@if (tableConfig()) {
  <ui-dataset-table
    [data]="vehicles()"
    [config]="tableConfig()!"
    [initialSelectedIds]="forcedSelectedIds()"
    (rowAction)="onRowAction($event)"
    (selectionChange)="onSelectionChange($event)"
  ></ui-dataset-table>
}

<!-- CELL TEMPLATES -->
<ng-template #imageCell let-row>
  <ui-vehicle-icon [vehicle]="row"></ui-vehicle-icon>
</ng-template>

<ng-template #licensePlateCell let-row>
  <div uiTruncateText>
    {{ row.plate | uppercase }}
  </div>
</ng-template>

<ng-template #ownerCell let-row>
  <div uiTruncateText>{{ row.owner || '—' }}</div>
</ng-template>

<ng-template #makeCell let-row>
  <div uiTruncateText>{{ row.make }}</div>
</ng-template>

<ng-template #colorCell let-row>
  <div uiTruncateText>{{ row.color | translate | titlecase }}</div>
</ng-template>

